const api = '/app-api';
export default {
  deleteUser: api + '/user-logout',
  getDeleteStatus: api + '/user-get-logout-status',
  cancelDelete: api + '/user-logout-repeal'
}
